module.exports = __webpack_public_path__ + "img/2.4bfd9238.jpg";